import { render } from "./features-showcase-cta.vue?vue&type=template&id=07c60abb&scoped=true&ts=true"
import script from "./features-showcase-cta.vue?vue&type=script&lang=ts"
export * from "./features-showcase-cta.vue?vue&type=script&lang=ts"

import "./features-showcase-cta.vue?vue&type=style&index=0&id=07c60abb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c60abb"]])

export default __exports__